import {useEffect} from "react";
import FormData from "form-data";
import {Buffer} from "buffer";
import axios from "axios";

import config from '../config.json';

const useUpdateImageInterval = (template, imageEdited, setImageEdited) => {
    return useEffect(() => {
        const interval = setInterval(async () => {
            if (!imageEdited) return;

            console.log('Updating image...');
            setImageEdited(false);

            const element = document.getElementById('image-container').firstChild.cloneNode(true);

            element.querySelectorAll('path.highlight').forEach(element => element.classList.remove('highlight'));

            const formData = new FormData();

            formData.append("image", Buffer.from(element.outerHTML).toString('base64'));
            formData.append("id", template._id);

            axios({
                url: `${config.backendUrl}/maps/templates/image/${template._id}`,
                withCredentials: true,
                method: "post",
                headers: { "Content-Type": "multipart/form-data" },
                data: formData
            })
                .then(() => console.log('Updated image'))
                .catch(error => console.log(error));
        }, 10000);

        return () => clearInterval(interval);
    }, [imageEdited, setImageEdited, template]);
}

export default useUpdateImageInterval;
